import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import farmer from "./farmer.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    farmer,
    htmlClass,
    config,
    breadcrumbs
  }
});
